// Shared constants for node types, roles, and connection types
// Used by Dashboard, ELedgers, NodeNetworkGraph, NodeDetail

export const NODE_TYPE_COLORS = {
  extraction_raw_material:    '#795548',  // brown - earth/raw material
  agricultural_production:    '#8bc34a',  // green - nature/agriculture
  refinery_intermediate:      '#ff9800',  // orange - industrial processing
  component_manufacturing:    '#2196f3',  // blue - manufacturing/tech
  final_assembly:             '#9c27b0',  // purple - assembly/completion
  warehouse_distribution:     '#607d8b',  // blue-grey - storage/logistics
  transit_hub:                '#00bcd4',  // cyan - transport/flow
  retail_point_of_sale:       '#f44336',  // red - commerce/sales
  use_phase:                  '#3f51b5',  // indigo - usage/consumption
  end_of_life_recovery:       '#4caf50',  // green - recycling/recovery
  corporate_admin:            '#9e9e9e'   // grey - admin/office
};

export const NODE_ROLE_LABELS = {
  producer:    'Producer',
  processor:   'Processor',
  trader:      'Trader',
  transporter: 'Transporter',
  storage:     'Storage',
  consumer:    'Consumer',
  regulator:   'Regulator',
  auditor:     'Auditor',
  other:       'Other'
};

export const CONNECTION_TYPE_COLORS = {
  supply: '#78909c',
  transfer: '#66bb6a',
  oversight: '#ef5350',
  verification: '#ab47bc',
  data_exchange: '#29b6f6'
};

export const NODE_TYPES = [
  'extraction_raw_material', 'agricultural_production', 'refinery_intermediate',
  'component_manufacturing', 'final_assembly', 'warehouse_distribution',
  'transit_hub', 'retail_point_of_sale', 'use_phase',
  'end_of_life_recovery', 'corporate_admin'
];

export const NODE_ROLES = [
  'producer', 'processor', 'trader', 'transporter',
  'storage', 'consumer', 'regulator', 'auditor', 'other'
];

export const ISSUE_SEVERITY_COLORS = {
  high: '#ef5350',
  medium: '#ff9800',
  low: '#4caf50'
};

export const SCOPE_COLORS = {
  S1: '#ef5350',
  S2: '#ff9800',
  S3: '#42a5f5',
  unscoped: '#9e9e9e'
};

export const PACT_STATUS_COLORS = {
  synced: '#4caf50',
  pending: '#ff9800',
  error: '#ef5350'
};

export function formatEmissions(kgCO2e) {
  if (kgCO2e == null) return '0 kg';
  const tonnes = kgCO2e / 1000;
  if (tonnes >= 1000) return `${(tonnes / 1000).toFixed(1)} kt CO2e`;
  if (tonnes >= 1) return `${tonnes.toFixed(1)} t CO2e`;
  return `${kgCO2e.toFixed(1)} kg CO2e`;
}

export function formatNumber(num) {
  if (num == null) return '0';
  return num.toLocaleString();
}
